// MA-935 (D-TUX-23) — a claim code from a hand-allowlisted teacher's class
// admits one parent past the private-beta gate.
//
// The one client call to `admit_by_claim_code` (DRAFT migration
// 0056_claim_code_admissions.sql, founder applies). The server decides
// everything: it answers only 'admitted', 'already' or 'refused', and writes
// nothing but the caller's parents row (when missing) and one admission row.
// This wrapper never throws and never treats anything it does not recognise
// as an admission (fail closed):
//   - a PGRST202 (function not in the schema cache — the pre-apply state)
//     is `not-live`, and PrivateBetaScreen then shows today's text;
//   - any other error, or any answer outside the three words, is `error`.
import { supabase } from "@/supabaseClient.js";
import { isMissingFunctionError } from "./claimApi";
import type { SupabaseClient } from "./classApi";

export type AdmitOutcome = "admitted" | "already" | "refused" | "not-live" | "error";

type RpcClient = Pick<SupabaseClient, "rpc">;

export async function admitByClaimCode(code: string, client: RpcClient = supabase): Promise<AdmitOutcome> {
  try {
    const { data, error } = await client.rpc("admit_by_claim_code", { p_claim_code: code });
    if (error) return isMissingFunctionError(error) ? "not-live" : "error";
    if (data === "admitted" || data === "already" || data === "refused") return data;
    return "error";
  } catch {
    return "error";
  }
}
